export default __webpack_public_path__ + "static/media/upload.41c65e43.svg";